<template>
  <v-dialog v-model="show_modal" persistent eager max-width="800">
    <v-card>
      <v-form
        ref="form"
        v-model="form_validate_status"
        v-on:submit.prevent="add"
      >
        <v-card-title class="headline">
          ตั้งค่าหน่วยกิตวิชาวิทยานิพนธ์ (
          {{
            form_mode === FORM_MODES.ADD
              ? $t("config_academic.addnew")
              : $t("config_academic.edit")
          }}
          ) <br />
          {{ level == 2 ? "ระดับปริญญาโท" : "ระดับปริญญาเอก" }}
        </v-card-title>

        <hr />

        <v-card-text class="mt-5">
          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="12">
              <v-chip color="black" dark class="mr-2">
                {{ name_faculty }}
              </v-chip>
              <v-chip color="gray" class="mr-2">
                {{ name_curriculum }}
              </v-chip>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0" cols="12" md="12">
              <v-chip color="orange" dark class="mr-2">
                ปีรับเข้า {{ semester }}/{{ year }}
              </v-chip>
              <v-chip color="blue" dark>
                {{ name_study_plan }}
              </v-chip>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="12" md="4">
                <v-text-field
                label="รหัสวิชา"
                v-model="subject_id"
                outlined
                dense
                :rules="required"
                :readonly="form_mode === FORM_MODES.EDIT"
                :hint="form_mode === FORM_MODES.EDIT ? 'แก้ไขรหัสวิชาไม่ได้ ต้องลบแล้วเพิ่มใหม่' : ''"
                :persistent-hint="form_mode === FORM_MODES.EDIT"
                />
            </v-col>
            <v-col cols="12" md="4">
              <span
                v-show="subject_name"
                class="mr-5"
                :style="{
                  color:
                    subject_type === 'T'
                      ? 'blue'
                      : subject_type === 'S'
                      ? 'yellow'
                      : 'red',
                  fontWeight: 'bold',
                }"
              >
                -{{ subject_type }}- </span
              >{{ subject_name }}</v-col
            >
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                label="หน่วยกิตทั้งหมด"
                v-model="credit_all"
                dense
                type="number"
                :rules="required"
                :style="{ backgroundColor: credit_all ? '#d0f0f2' : '' }"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="2">
              <v-text-field
                label="เทอม 1"
                v-model="term1"
                dense
                type="number"
                :rules="required"
                :style="{ backgroundColor: term1 ? '#d0f0f2' : '' }"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="เทอม 2"
                v-model="term2"
                dense
                type="number"
                :rules="required"
                :style="{ backgroundColor: term2 ? '#d0f0f2' : '' }"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="เทอม 3"
                v-model="term3"
                dense
                type="number"
                :style="{ backgroundColor: term3 ? '#d0f0f2' : '' }"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="เทอม 4"
                v-model="term4"
                dense
                type="number"
                :style="{ backgroundColor: term4 ? '#d0f0f2' : '' }"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="เทอม 5"
                v-model="term5"
                dense
                type="number"
                :style="{ backgroundColor: term5 ? '#d0f0f2' : '' }"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="เทอม 6"
                v-model="term6"
                dense
                type="number"
                :style="{ backgroundColor: term6 ? '#d0f0f2' : '' }"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="เทอม 7"
                v-model="term7"
                dense
                type="number"
                :style="{ backgroundColor: term7 ? '#d0f0f2' : '' }"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="เทอม 8"
                v-model="term8"
                dense
                type="number"
                :style="{ backgroundColor: term8 ? '#d0f0f2' : '' }"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="เทอม 9"
                v-model="term9"
                dense
                type="number"
                :style="{ backgroundColor: term9 ? '#d0f0f2' : '' }"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="เทอม 10"
                v-model="term10"
                dense
                type="number"
                :style="{ backgroundColor: term10 ? '#d0f0f2' : '' }"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pb-5 pr-4">
          <v-spacer></v-spacer>
            <v-btn
            class="ml-5"
            color="success"
            @click="form_validate()"
            :disabled="!form_validate_status || !subject_name"
            >
            บันทึก
          </v-btn>
          <v-btn color="error" @click="show_modal = false">ยกเลิก</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import ConfigProvider from "@/services/config.provider";
import GenericProvider from "@/services/generic.provider";

const configService = new ConfigProvider();
const genericService = new GenericProvider();
const FORM_MODES = { ADD: 0, EDIT: 1 };

export default {
  name: "ConfigGraduateSeparateThesisCreditAddEditDialog",

  props: {
    toggle_loading: Function,
    fetch_data: Function,
  },

  data: () => ({
    FORM_MODES,
    semesters: ["1", "2"],

    form_mode: null,
    form_validate_status: null,
    show_modal: false,

    level: null,
    faculty_id: null,
    curriculum_id: null,
    year: null,
    semester: null,
    study_plan_id: null,
    prog_id: null,
    sub_prog_id: null,
    name_faculty: null,
    name_curriculum: null,
    name_study_plan: null,
    subject_id: null,
    subject_name: null,
    subject_type: null,
    credit_all: null,

    term1: null,
    term2: null,
    term3: null,
    term4: null,
    term5: null,
    term6: null,
    term7: null,
    term8: null,
    term9: null,
    term10: null,

    required: [(v) => !!v || "Required"],
  }),

  components: {},

  computed: {},

  methods: {
    open_add_modal: function (
      selected_level,
      selected_faculty_id,
      selected_curriculum_id,
      selected_year,
      selected_semester,
      selected_study_plan_id,
      selected_prog_id,
      selected_sub_prog_id,
      name_faculty,
      name_curriculum,
      name_study_plan
    ) {
      this.show_modal = true;
      this.form_mode = FORM_MODES.ADD;
      this.level = selected_level;
      this.faculty_id = selected_faculty_id;
      this.curriculum_id = selected_curriculum_id;
      this.year = selected_year;
      this.semester = selected_semester;
      this.study_plan_id = selected_study_plan_id;
      this.prog_id = selected_prog_id;
      this.sub_prog_id = selected_sub_prog_id;
      this.name_faculty = name_faculty;
      this.name_curriculum = name_curriculum;
      this.name_study_plan = name_study_plan;
      this.subject_id = null;
      this.subject_name = null;
      this.subject_type = null;
      this.credit_all = null;
      this.term1 = null;
      this.term2 = null;
      this.term3 = null;
      this.term4 = null;
      this.term5 = null;
      this.term6 = null;
      this.term7 = null;
      this.term8 = null;
      this.term9 = null;
      this.term10 = null;
    },

    open_edit_modal: function (
      selected_level,
      selected_faculty_id,
      selected_curriculum_id,
      selected_year,
      selected_semester,
      selected_study_plan_id,
      selected_prog_id,
      selected_sub_prog_id,
      name_faculty,
      name_curriculum,
      item
    ) {
      this.show_modal = true;
      this.form_mode = FORM_MODES.EDIT;
      this.level = selected_level;
      this.faculty_id = selected_faculty_id;
      this.curriculum_id = selected_curriculum_id;
      this.year = selected_year;
      this.semester = selected_semester;
      this.study_plan_id = selected_study_plan_id;
      this.prog_id = item.prog_id;
      this.sub_prog_id = item.sub_prog_id;
      this.name_faculty = name_faculty;
      this.name_curriculum = name_curriculum;
      this.name_study_plan = item.study_plan_name;
      this.credit_all = item.credit_all;
      this.subject_id = item.subject_id;
      this.term1 = item.term1;
      this.term2 = item.term2;
      this.term3 = item.term3;
      this.term4 = item.term4;
      this.term5 = item.term5;
      this.term6 = item.term6;
      this.term7 = item.term7;
      this.term8 = item.term8;
      this.term9 = item.term9;
      this.term10 = item.term10;
    },

    form_validate: function () {
      this.$refs.form.validate();
      if (
        this.form_mode === FORM_MODES.ADD ||
        this.form_mode === FORM_MODES.EDIT
      ) {
        this.addAndEdit();
      }
    },

    async get_subject_data() {
      this.subject_name = null;
      this.subject_type = null;
      let response = await genericService
        .getRegistrarSubject(2, this.subject_id)
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
        });
      if (response[0]) {
        this.subject_name = response[0].subject_name_en;
        this.subject_type = response[0].subject_type;
      }
    },

    addAndEdit: async function () {
      this.show_modal = false;
      this.toggle_loading(true);

      let response = await configService
        .setGraduateSeparateThesisCredit({
          faculty_id: this.faculty_id,
          curr_id: this.curriculum_id,
          admis_year: this.year,
          admis_term: this.semester,
          prog_id: this.prog_id,
          sub_prog_id: this.sub_prog_id,
          subject_id: this.subject_id,
          credit_all: this.credit_all,
          term1: this.term1 == null || this.term1 == 0 ? "" : this.term1,
          term2: this.term2 == null || this.term2 == 0 ? "" : this.term2,
          term3: this.term3 == null || this.term3 == 0 ? "" : this.term3,
          term4: this.term4 == null || this.term4 == 0 ? "" : this.term4,
          term5: this.term5 == null || this.term5 == 0 ? "" : this.term5,
          term6: this.term6 == null || this.term6 == 0 ? "" : this.term6,
          term7: this.term7 == null || this.term7 == 0 ? "" : this.term7,
          term8: this.term8 == null || this.term8 == 0 ? "" : this.term8,
          term9: this.term9 == null || this.term9 == 0 ? "" : this.term9,
          term10: this.term10 == null || this.term10 == 0 ? "" : this.term10,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.toggle_loading(false);
        });
      this.fetch_data();
      if (response && response.status)
        this.$toasted.success(this.$t("toasted.create_successfully"));
      else this.$toasted.error(this.$t("toasted.cannot_create"));
    },
  },

  watch: {
    subject_id: {
      handler: function () {
        if (this.subject_id.length === 8) {
          this.get_subject_data();
        } else {
          this.subject_name = null;
          this.subject_type = null;
        }
      },
    },
  },

  mounted: function () {},
};
</script>
<style scoped>
.warning-text {
  color: white;
  background-color: rgb(226, 162, 42);
  border-radius: 5px;
  padding: 5px;
}
</style>
